export const configTeamLeaderProspectMonitoringTeam = [
    {name: "namaTeamLead", label: "Nama TL", options: {sort: false}},
    {name: "newProspect", label: "NEW\nPROSPEK", options: {sort: false}},
    {name: "newProspectRate", label: "rate%", options: {sort: false}},
    {name: "nonFU", label: "NON FU", options: {sort: false}},
    {name: "nonFURate", label: "rate%", options: {sort: false}},
    {name: "ongoing", label: "ONGOING", options: {sort: false}},
    {name: "ongoingRate", label: "rate%", options: {sort: false}},
    {name: "pending", label: "PENDING", options: {sort: false}},
    {name: "pendingRate", label: "rate%", options: {sort: false}},
    {name: "deal", label: "DEAL", options: {sort: false}},
    {name: "dealRate", label: "rate%", options: {sort: false}},
    {name: "drop", label: "DROP", options: {sort: false}},
    {name: "dropRate", label: "rate%", options: {sort: false}}
];

export const configSalesmanProspectMonitoringTeam = [
    {name: "namaSalesmanCS", label: "Nama Salesman/CS", options: {sort: false}},
    {name: "newProspect", label: "NEW\nPROSPEK", options: {sort: false}},
    {name: "newProspectRate", label: "rate%", options: {sort: false}},
    {name: "nonFU", label: "NON FU", options: {sort: false}},
    {name: "nonFURate", label: "rate%", options: {sort: false}},
    {name: "ongoing", label: "ONGOING", options: {sort: false}},
    {name: "ongoingRate", label: "rate%", options: {sort: false}},
    {name: "pending", label: "PENDING", options: {sort: false}},
    {name: "pendingRate", label: "rate%", options: {sort: false}},
    {name: "deal", label: "DEAL", options: {sort: false}},
    {name: "dealRate", label: "rate%", options: {sort: false}},
    {name: "drop", label: "DROP", options: {sort: false}},
    {name: "dropRate", label: "rate%", options: {sort: false}}
];
